/**
 * PRP-FLOOD-1 work item 3 (FL2): the signed-in user's scope settings. Today one switch:
 * `nfip_no_bagging` — use no-bagging tear-out items on NFIP flood claims (off by default;
 * Cat 3 removals are bagged per IICRC S500, decision 0052).
 *
 * Contract: GET / PUT /api/v1/me/scope-settings, body and response `{nfip_no_bagging}`.
 * Same auth/fetch path as headingsApi.ts; failures arrive as `ApiError` (with `status`).
 */
import { api } from './api';

export interface ScopeSettings {
  nfip_no_bagging: boolean;
  /** PRP-NOTES-1: the account's note level for chat's suggested customer notes (default brief). */
  note_level?: 'none' | 'brief' | 'detailed';
}

export const getScopeSettings = async (): Promise<ScopeSettings> => api.get('/me/scope-settings');

export const updateScopeSettings = async (body: Partial<ScopeSettings>): Promise<ScopeSettings> =>
  api.put('/me/scope-settings', body);
